import { SendIcon } from "@minket/brand/icons/send";
import { createFileRoute } from "@tanstack/react-router";
import { StepPage } from "@/components/onboarding/step-page";
import { SendTestAction } from "@/components/sending/actions";
import { GatedAction } from "@/components/sending/available";
import { CopyBlock } from "@/components/tenancy/copy";
import { apiBaseUrl } from "@/components/tenancy/format";

export const Route = createFileRoute("/onboarding/test")({
  component: TestStep,
});

const action = { label: "Send test email", icon: SendIcon } as const;

/** The same send from a terminal, in Minket's own notation (D31). */
function curl(base: string): string {
  return [
    `curl ${base}/v1/emails \\`,
    `  -H "Authorization: Bearer $MINKET_API_KEY" \\`,
    `  -H "Content-Type: application/json" \\`,
    `  -d '{"from": "you@your-domain", "to": "delivered@minket.test", "subject": "Hello", "text": "It works."}'`,
  ].join("\n");
}

function TestStep() {
  return (
    <StepPage
      path="/onboarding/test"
      intro="Send a test email and follow it on its email page, from accepted to delivered. With the test key it lands in test mode instead, and nothing leaves."
      asks={[
        {
          title: "A recipient",
          text: "Your own address, or delivered@minket.test to see delivery without sending anything.",
        },
        {
          title: "A verified domain",
          text: "Live mail comes from the domain verified in the domain step. Test mode also accepts any address on minket.test.",
        },
      ]}
      action={action}
      control={
        <GatedAction
          list="emails"
          pending={{ ...action, align: "start" }}
          permission="emails.send"
          forbidden="Viewers cannot send email"
        >
          {(projectId) => <SendTestAction projectId={projectId} />}
        </GatedAction>
      }
    >
      <CopyBlock label="Or from a terminal" value={curl(apiBaseUrl())} className="max-w-3xl" />
    </StepPage>
  );
}
